import { render, staticRenderFns } from "./BeerCompetition.vue?vue&type=template&id=a0b3c7fa&"
import script from "./BeerCompetition.vue?vue&type=script&lang=js&"
export * from "./BeerCompetition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports